import { randInt } from '@/lib/funcs'
import { industryTypes, reportLengths, reportTxtStyles, colors } from '@/lib/consts'

let numDemos = 3
let randColorIdx = randInt( 0, colors.length )

export default {
  state: {
    didView: false,
    industry: industryTypes.mktg.id,
    length: reportLengths.short,
    scrollSpeed: reportTxtStyles.default,
    colorIdx: randColorIdx,
    color: colors[ randColorIdx ].main,
    accent: colors[ randColorIdx ].accent
  },
  mutations: {
    setViewed ( state, bool ) {
      state.didView = bool
    },
    setIndustry ( state, str ) {
      state.industry = str
    },
    setLength ( state, num ) {
      state.length = num
    },
    setSpeed ( state, num ) {
      state.scrollSpeed = num
    },
    setColorIdx ( state, num ) {
      state.colorIdx = num
    },
    setColor ( state, str ) {
      state.color = str
    },
    setAccent ( state, str ) {
      state.accent = str
    }
  },
  actions: {
    setViewed ( { commit, dispatch }, bool = true ) {
      commit( 'setViewed', bool )
      if ( bool ) {
        while ( numDemos >= 1 ) {
          dispatch( 'enableDemo', numDemos )
          --numDemos
        }
      }
    },
    setIndustry ( { commit }, str ) {
      commit( 'setIndustry', str )
    },
    setReportLength ( { commit }, num ) {
      commit( 'setLength', num )
    },
    setReportStyle ( { commit }, num ) {
      commit( 'setSpeed', num )
    },
    setColors ( { commit }, idx ) {
      commit( 'setColorIdx', idx )
      commit( 'setColor', colors[ idx ].main )
      commit( 'setAccent', colors[ idx ].accent )
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/report.js